
































import { mapMutations } from "vuex";
import { General } from "@/utils/constants";
import ModalExternalAssign from "@/views/App/ModalExternalAssign";

export default {
  name: "CustomSubscriberList",
  props: {
    subscriber: {
      type: Object,
      default: () => {}
    },
    editFunction: {
      type: Function,
      default: null
    }
  },

  data() {
    return {
      General
    };
  },

  computed: {
    subsctiberCapacity() {
      return this.subscriber.capacity_selected || this.subscriber.capacity;
    },

    partAbbreviation() {
      return this.subsctiberCapacity
        ? this.subsctiberCapacity.entity.abbreviation
        : "";
    },

    categoryDescription() {
      return this.subscriber.bonds.length > 0
        ? this.subscriber.bonds[0].category_description
        : "";
    },

    partFormated() {
      if (this.subsctiberCapacity) {
        const bound = this.subsctiberCapacity;
        const description = bound.description ? `- ${bound.description}` : "";
        const abbreviation = bound.abbreviation.includes("/")
          ? bound.abbreviation.split("/")[1]
          : bound.abbreviation;
        return ` / ${abbreviation} ${description}`;
      }
      return "";
    }
  },

  methods: {
    ...mapMutations({
      removeSubscriber: "removeSubscriber",
      editSubscriber: "editSubscriber"
    }),

    edit() {
      (this.editFunction ? this.editFunction : this.editDefaultAction)(
        this.subscriber
      );
    },

    editDefaultAction() {
      this.$buefy.modal.open({
        parent: this as any,
        props: {
          edit: this.subscriber,
          onClose: this.editSubscriber
        },
        component: ModalExternalAssign,
        hasModalCard: true,
        trapFocus: true
      });
    },

    actionList() {
      return [
        {
          label: this.General.EDIT,
          icon: "square-edit-outline",
          validated: typeof this.subscriber.id === "string",
          callback: () => this.edit()
        },
        {
          label: this.General.DELETE,
          icon: "delete",
          validated: Boolean(this.subscriber.id),
          callback: () => this.removeSubscriber(this.subscriber)
        }
      ];
    }
  }
};
